import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StartClient } from '../clients/bedomningsportal-api/start.client';

@Injectable({ providedIn: 'root' })
export class EnvironmentInfoQuery {
  constructor(private startClient: StartClient) {}

  public getEnvironmentInfoText(): Observable<string> {
    return this.startClient.getEnvironmentInfoText();
  }
}
